import React, { Component } from 'react';
import __ from 'lodash';
import {cekCookies} from '../../../../actions';
import {connect} from 'react-redux';
import { CONFIG } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import { Form,Row, Col, Alert} from 'react-bootstrap';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import LoaderModal from '../../../modal/LoaderModal';
import CreateHwRequest from '../../../../entity/CreateHwRequest';

class AddEditHw extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isFetching: false,
            profil: CreateHwRequest,
            kelas: [],
            mapel: [],
            tematik: [],
            action: 'add',
            resMessage: null
        };
        //this.essayOnChange = this.essayOnChange.bind(this);
    }

    getKelas = async() => {
        this.setState({isFetching: true})
        const res = await accountManagement.get(CONFIG.GET_KELAS_BY_GURU + this.props.account.idGuru).catch(function(error){
        })
        if(res){
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    kelas: res.data.data                    
                })
            } else {
                this.setState({ resMessage: res.data.errorSchema.errorMessage})
            }
            this.setState({ isFetching: false });
        } 
        
    }

    getMapel = async(id) => {
        this.setState({isFetching: true});
        const resMapel = await accountManagement.get(CONFIG.GURU_GET_MAPEL_BY_KELAS, {
            params: {['idKelas']: id, ['idGuru']: this.props.account.idGuru}
        }).catch(function(error){
        })
        if(resMapel){           
            if(resMapel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    mapel: resMapel.data.data
                    //profil: {...this.state.profil, ['idKelas']: id}
                })  
            }
            this.setState({isFetching: false});
        }    
    }

    getTematik = async(id) => {
        this.setState({isFetching: true});
        const res = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_FETCH_TEMATIK_BY_ID_KELAS, {
            params: {idKelas: id}
        }).catch(function(error){
        })
        if(res){
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    tematik: res.data.data
                })   
            }
            this.setState({isFetching: false});  
        }    
    }
    

    getById = async() => {
        this.setState({isFetching: true, profil: {} })
        const res = await accountManagement.get(CONFIG.HW_GET_BY_ID + this.props.idProfilCbt).catch(function(error){
        })
        if(res){
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    profil: res.data.data                    
                })
                this.getMapel(res.data.data.idKelas)
                this.getTematik(res.data.data.idKelas)
            } else {
                this.setState({ resMessage: res.data.errorSchema.errorMessage})
            } 
            this.setState({ isFetching: false });
        } 
        
    }

    async componentDidMount() {        
        this.setState({isFetching: true})
        await this.props.cekCookies();       
        if(!__.isEmpty(this.props.account)) {            
            this.getKelas();
        }
        if(this.props.idProfilCbt !== null) {
            this.getById();
            this.setState({action: 'edit'})
        }
        this.setState({isFetching: false})
    }

    onChangeKelas = async (data) => {  
        const idKelas = data.target.value;
        this.setState({ profil: {...this.state.profil, idKelas: idKelas} })
        this.setState({mapel:[], tematik:[]});
        this.getMapel(idKelas);   
        this.getTematik(idKelas);        
    }

    mapelOnChange = async(data) => {
        const idMapel = data.target.value;
        this.setState({ profil: {...this.state.profil, idMataPelajaran: idMapel, idTematik: null} })
    }

    temaOnChange = async(data) => {
        const idTematik = data.target.value;
        this.setState({ profil: {...this.state.profil, idTematik: idTematik, idMataPelajaran: null} })
    }

    namaOnChange = async(data) => {
        const nama = data.target.value;
        this.setState({ profil: {...this.state.profil, ['namaProfil']: nama} })
    }

    essayOnChange = async(data) => {
        const essay = data.target.value;
        const re = /^[0-9\b]+$/;
        if (essay === '' || re.test(essay) && Number(essay) <= 100) {
            this.setState({ profil: {...this.state.profil, ['prosentaseEssay']: essay} })
        }
        
    }

    kkmOnChange = async(data) => {
        const kkm = data.target.value;
        const re = /^[0-9\b]+$/;
        if (kkm === '' || re.test(kkm) && Number(kkm) <= 100) {
            this.setState({ profil: {...this.state.profil, ['ketuntasanMinimum']: kkm} })
        }        
        
    }

    renderKelas(){
        const {kelas, profil} = this.state;
        if(!__.isEmpty(kelas)){
            return kelas.map((kel) => {
                if(kel.ID_KELAS === profil.idKelas) {
                    return ( <option value={kel.ID_KELAS} selected>{kel.NAMA_KELAS}</option> )
                } else {
                    return ( <option value={kel.ID_KELAS}>{kel.NAMA_KELAS}</option> )
                }
                
            })
        }
    }   

    onSubmit = async(event) => {        
        event.preventDefault();
        const {profil, action} = this.state;
        console.log('profil', profil)
        if(profil.idMataPelajaran === null && profil.idTematik === null) {
            this.setState({resMessage: 'Mata Pelajaran atau Tematik harus dipilih...'})
            return false;
        }
        this.setState({isFetching: true, resMessage: null})

        let POST_URL = null;
        if(action === 'add') {
            POST_URL = CONFIG.HW_ADD;
        } else POST_URL = CONFIG.HW_UPDATE;

        const res = await accountManagement.post(POST_URL, {...profil,
            ['idSekolah']: this.props.account.idSekolah,
            ['idGuru']: this.props.account.idGuru,
            ['prosentaseEssay']: profil.prosentaseEssay === null ? '0' : profil.prosentaseEssay,
            ['ketuntasanMinimum']: profil.ketuntasanMinimum === null ? '65' : profil.ketuntasanMinimum
        }).catch(function(error){ console.log(error) })
        
        if(res){
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                if(action === 'add') {
                    window.location.pathname = "/examsoal/" + res.data.data.idSubProfilCbt + "/homework";       
                } else {
                    this.handleBack();
                    window.location.pathname = "/homework";  
                }
                         
            } else {
                this.setState({ 
                    resMessage: res.data.errorSchema.errorMessage,
                    isFetching: false
                })
            } 
            //this.setState({ isFetching: false });
        } 
        
    }

    render() {
        const {profil, action} = this.state; 
        let pageTitle;
        if(action === 'edit') {
            pageTitle = "Edit Homework";
        } else {
            pageTitle = "Add Homework";
        }

        return (
            <> {this.loadAlert()}  
                <h4>{pageTitle}</h4>
                <LoaderModal isFetching={this.state.isFetching} />
                <Col>
                    <Form onSubmit={this.onSubmit}>                    
                    <Form.Group controlId="nama">
                        <Form.Label>Judul : </Form.Label>
                        <Form.Control
                        type="text"
                        name="nama" 
                        maxLength="100"
                        defaultValue={profil.namaProfil} onChange={this.namaOnChange}                                 
                        placeholder="Input text here..." required/>
                    </Form.Group>
                    <Row>
                        <Col sm={4}>
                            <Form.Group controlId="kelas">
                                <Form.Label>Kelas :</Form.Label>
                                <select className="form-control" name="kelas" defaultValue={profil.idKelas} onChange={this.onChangeKelas} required>
                                    <option value="">Pilih Kelas...</option>
                                    {this.renderKelas()}
                                </select>
                            </Form.Group>
                        </Col>

                        {!__.isEmpty(this.state.mapel) && 
                        <Col>
                            <Form.Group controlId="mapel">
                                <Form.Label>Mata Pelajaran :</Form.Label>
                                <select className="form-control" name="mapel" value={profil.idMataPelajaran === null ? '' : profil.idMataPelajaran} onChange={this.mapelOnChange} >
                                    <option value="">Pilih Mata Pelajaran...</option>
                                    {this.state.mapel.map((data,i) => 
                                        <option key={i} value={data.idMataPelajaran}>{data.namaMataPelajaran}</option>
                                    )}
                                </select>
                            </Form.Group>
                        </Col>
                        }

                        {!__.isEmpty(this.state.tematik) && 
                        <Col>
                            <Form.Group controlId="tematik">
                                <Form.Label>Tematik :</Form.Label>
                                <select className="form-control" name="mapel" value={profil.idTematik === null ? '' : profil.idTematik} onChange={this.temaOnChange} >
                                    <option value="">Pilih Tema...</option>
                                    {this.state.tematik.map((data,i) => 
                                        <option key={i} value={data.idTematik}>{data.namaTematik}</option>
                                    )}
                                </select>
                            </Form.Group>
                        </Col>
                        }
                    </Row>

                    <Row>
                        <Col>
                            <Form.Group controlId="essay">
                                <Form.Label>Prosentase Essay</Form.Label>
                                <input className="form-control"
                                    type="text"
                                    name="essay" 
                                    pattern="[0-9]*"
                                    value={profil.prosentaseEssay === null ? '0' : profil.prosentaseEssay} 
                                    onChange={this.essayOnChange} 
                                    required />
                            </Form.Group>
                        </Col>

                        <Col>
                            <Form.Group controlId="kkm">
                                <Form.Label>Ketuntasan Minimum</Form.Label>
                                <input className="form-control"
                                    type="text"
                                    name="kkm"
                                    value={profil.ketuntasanMinimum === null ? '65' : profil.ketuntasanMinimum} onChange={this.kkmOnChange} required/>
                            </Form.Group>
                        </Col>
                    </Row>
                    
                    
                    <Form.Group>                        
                        <button type="button" className="btn btn-danger" onClick={() => this.handleBack()}><ArrowBackIosIcon fontSize="small"/>Batal</button>
                        {this.state.action === 'add' ?       
                            <button type="submit" className="btn btn-primary pull-right">Selanjutnya</button>
                            :
                            <button type="submit" className="btn btn-primary pull-right">Simpan</button>
                        }
                    </Form.Group>
                    </Form>
                </Col> 
            </>
        );
    }

    loadAlert = () => { 
        if (this.state.resMessage !== null) {
          return (
            <Alert variant="danger" onClose={() => this.setState({ resMessage: null })} dismissible>   
                <strong>{this.state.resMessage}</strong>
            </Alert>
          );
        } 
    }

    handleBack() {
        this.props.handleBack();
    }
}
const mapStateToProps = (state) => {
    return{
        account: state.account        
    };
}

export default connect(mapStateToProps, {cekCookies})(AddEditHw);